export default __webpack_public_path__ + "static/petrina-897851cb0e88710595890377e736a182.png";